// extracted by mini-css-extract-plugin
export default {"container":"accordion-container_container__4rLxy"};